// Services
import store from '../store'

// Utilities
import Analytics from './analyticsUtil'
import Language from './languageUtil'
import logger from '../utility/loggerUtil'
import permission from '../utility/permissionsUtil'
import { AppBrands, BrowserType } from '../constants'

class MessagingUtil {
  /**
   * Initializes the Messaging Platform for browser or app.
   */
  static async init () {
    try {
      if (window.hasOwnProperty('clevertap')) {
        // Setup for browser
        window.addEventListener('blur', this.addBrowserPopupCloseListener)
      }
      logger.info('MessagingUtil.init completed.')
    } catch (e) {
      logger.error('Error on MessagingUtil.init')
      logger.debug(e)
    }
  }

  /**
   * Updates CT identity and push/messaging settings for a customer (usually on login or link).
   */
  static async onLogin () {
    try {
      await Analytics.updateIdentity()

      this.askBrowserPermission()
    } catch (e) {
      logger.error('Error on MessagingUtil.onLogin')
      logger.debug(e)
    }
  }

  /**
   * Adds a listener to close the CT messaging popups on browser
   * This is needed because our Content Security Policy does not allow inline handlers
   * I am currently removing any onclicks or hrefs to prevent errors
   */
  static addBrowserPopupCloseListener () {
    // On blur, check if we are blurring to click on the iframe
    const iframe = document.querySelector('#wiz-iframe-intent') || document.querySelector('#wiz-iframe')
    if (iframe) {
      // If we have an iframe, try to locate the close button
      const closeButton = iframe.contentWindow.document.querySelector('.CT_InterstitialClose') || iframe.contentWindow.document.querySelector('.CT_BannerClose') || iframe.contentWindow.document.querySelector('.wzrkClose')
      if (closeButton) {
        closeButton.removeAttribute('onclick')
        closeButton.addEventListener('click', () => {
          // Remove all of the possible notification elements
          const wrappers = [
            document.getElementById('wizParDiv0'),
            document.getElementById('wizParDiv2'),
            document.getElementById('intentOpacityDiv'),
            document.getElementById('intentPreview')
          ]
          for (const wrapper of wrappers) {
            if (wrapper) {
              wrapper.remove()
            }
          }
        })
      }
    }
  }

  /**
   * Opens device settings page.
   */
  static openDeviceSettings () {
    try {
      permission.openAppSettingsPage()
    } catch (e) {
      logger.error('Error opening device settings page')
      logger.debug(e)
    }
  }

  /**
   * Opens a CleverTap popup which requests permission to send push notifications via Browser.
   * TODO: Add all other brands.
   */
  static askBrowserPermission () {
    if (!window.hasOwnProperty('clevertap') || store.state.display.browserType === BrowserType.Safari || !store.state.session.canUseCleverTap) {
      return
    }

    logger.info('CleverTap permission request window...')

    const isTmx = process.env.VUE_APP_AppBrand === AppBrands.tmx
    const buttonColor = isTmx ? '#00529b' : '#339328'

    window.clevertap.notifications.push({
      titleText: Language.$t('global.askbrowserpermission_titletext'),
      bodyText: Language.$t('global.askbrowserpermission_bodytext'),
      okButtonText: Language.$t('global.yes'),
      rejectButtonText: Language.$t('global.no'),
      okButtonColor: buttonColor,
      serviceWorkerPath: '../../../serviceWorker.js' // path to your custom service worker file  // '../../../services/serviceWorkers/serviceWorker.js'
    })
  }
}

export default MessagingUtil
